import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class BrevoNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the getSegments global action. */
    this.getSegments = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "getSegments",
      operationName: "getSegments",
      operationReturnType: "BrevoGetSegments",
      namespace: "brevo",
      variables: { customerId: { required: false, type: "String" } }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "brevo",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  BrevoNamespace
};
//# sourceMappingURL=brevo.js.map
